import {useState, useEffect} from 'react';
import {
	RootContainer,
	VideoContainer,
	QuestionContainer,
	QuestionCard,
	QuestionTitle,
	QuestionTime,
} from './Recording.styles.js';
import {PrimaryButton, VerticalSpace} from 'components';
import { oembed } from "@loomhq/loom-embed";
import {userActions} from 'modules/user';
import {useDispatch, useSelector, shallowEqual} from 'react-redux';
import {useParams} from 'react-router-dom';
import moment from 'moment';

const Recording = () => {
	const {id} = useParams()
	const dispatch = useDispatch()
	const {allAnswers} = useSelector(state => state.user, shallowEqual)
	const [videoHTML, setVideoHTML] = useState("");

	useEffect(() => {
		dispatch(userActions.getAllAnswersAsyncActions.request({data: id, callback: () => null}))
	}, [])

	useEffect(() => {
		const getLoomEmbed = async (videoId) => {
			// console.log("LOOM EMBED", ((window.innerWidth/4)*3))
			const { html } = await oembed(`https://www.loom.com/share/${videoId}`, {height: window.innerHeight});
        	setVideoHTML(html);
		}
		if(allAnswers.length) {
			getLoomEmbed(allAnswers[0].videoId)
		}
	}, [allAnswers])

	return (
		<RootContainer>
			<VideoContainer dangerouslySetInnerHTML={{ __html: videoHTML }} >
			</VideoContainer>
			<QuestionContainer>
				{
					allAnswers[0]?.answers?.map(answer => (
						<QuestionCard>
							<QuestionTitle>Q{answer.questionNumber}: {answer.question}</QuestionTitle>
							<QuestionTime>{moment.duration(answer.time*1000).minutes()} min {moment.duration(answer.time*1000).seconds()} secs</QuestionTime>
						</QuestionCard>
					))
				}
				<VerticalSpace count={3} />				
			</QuestionContainer>
		</RootContainer>
	)
}

export default Recording;